export default __webpack_public_path__ + "static/media/bcch-logo.fd3616cd.png";